module.exports = __webpack_public_path__ + "static/media/female-concierge.5b8e54eb.png";